<template>
  <div id="component-ItemsRack" style="position: relative;display: block;">
    <div id="btnNav" style="width: 150px;min-width:150px;display: block;float left; text-align: left;float: left;">
      <div id="btnViews">
        <span v-if="view === 'przod' || view === 'tyl'" style="width:100%; display: block;margin-top: 15px;">{{$t('message.miejsce')}}:</span>
        <p v-if="view === 'przod'" style="color: #959594;">
        {{$t('message.miejsce_urzadzenia')}}: {{zajeteMiejscePrzod}}<br>
        {{$t('message.miejsce_wolne')}}: {{wolneMiejscePrzod}}
        </p>
        <p v-if="view === 'tyl'" style="color: #959594;">
        {{$t('message.miejsce_urzadzenia')}}: {{zajeteMiejsceTyl}}<br>
        {{$t('message.miejsce_wolne')}}: {{wolneMiejsceTyl}}
        </p>

        <span style="width:85px; display: block;">{{$t('message.widok')}}:
          <md-avatar style="width: 16px;min-width: 16px;height: 22px;position: relative;right: 0px;bottom: 0px;float: right;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16"
            style="margin-right;margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
            <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
            </svg>
            <md-tooltip md-direction="right" class="tooltipShort">
              {{$t('message.glebokosc_urzadzen')}}
            </md-tooltip>
          </md-avatar>
        </span>

        <button id="btnView" @click="view = 'przod', lista = 'przod'" class="btn" :class="(view === 'przod' && !disabledView) ? 'active' : ''" :disabled="disabledView">{{$t('message.przod')}}</button>
        <button id="btnView" @click="view = 'tyl', lista = 'tyl'" class="btn" :class="(view === 'tyl' && !disabledView) ? 'active' : ''" :disabled="disabledView">{{$t('message.tyl')}}</button>
        <br>
        <span style="width:100%; display: block; margin-top:20px">{{$t('message.dodatkowe')}}:</span>
        <!-- <button id="btnView" @click="view = 'inne'" class="btn" :class="(view === 'inne' && !disabledView) ? 'active' : ''" :disabled="disabledView">inne</button> -->
      </div>
      <!-- układanie szafy inne -->
      <div id="szafaInne">
        <div class="list-group-item-inne" v-for="(elInne, idInne) in szafaInne" :key="idInne" style="width: 100%;height: 45px;display: inline-flex;">
          <span style="width: 40px !important;display: block;float: left;height: 36px;margin-top: 6px;margin-right: 6px;">
            <img style="height: 35px;" :src="getImgUrl(elInne.symbol)">
          </span>
          <span style="margin-top: 8px;">
            <input class="form-control form-control-sm" style="width: 70px;" v-on:input="dodanie_sztuk(inputInne, elInne.symbol)" type='number'
            min=1 max=99 v-model="inputInne[elInne.symbol]"/>
            <!-- <i class="fa fa-times close" @click="deleteItem(idInne, elInne.nr, elInne.symbol, 'inne')" -->
            <i class="fa fa-times close" @click="deleteItem(idInne, 'inne')"
            style="font-size: 12px;color: red;line-height: 0px;position: relative;right: -21px; top: -30px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
              </svg>
            </i>
            <md-avatar style="width: 16px;min-width: 16px;height: 22px;position: relative;right: -73px;bottom: 15px;float: left;"
            v-if="elInne.symbol === 'RAWP'">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right;margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
              <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
              </svg>
              <md-tooltip md-direction="right" class="tooltipShort" v-html="$t('message.info_RAWP')" style="height: auto;"></md-tooltip>
            </md-avatar>
          </span>

        </div>
      </div>

    </div>
    <!-- układanie szafy front -->
    <div id="info-blink" v-if="!inputs.szafaPrefix && !inputs.szafaPrefix !== ''">
      <p class="blink">{{$t('message.start_confi')}}</p>
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" class="bi bi-arrow-right blink" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>
      </svg>
    </div>

    <div id="szafa"
    style="position:relative;width: 410px;min-width: 410px;background-repeat: no-repeat;background-size: cover; margin-top:20px; float: left"
    :style="(!inputs.sameAkcesoria) ? [BgImageTop('szafa/szafa_' + Number(outputs.szafa.wysokosc_montazowa) + '.svg'), {height: hBox(Number(outputs.szafa.wysokosc_montazowa)) + 'px'}]: [{height: hBox(Number(outputs.szafa.wysokosc_montazowa)) + 'px'}]"
    v-if="outputs.szafa && Number(outputs.szafa.wysokosc_montazowa) > 0 && view ==='przod'"
    >
    <div v-if="!inputs.sameAkcesoria"><img src="../assets/icon-pulsar.png" style="width: 35px;position: absolute;left: 35px;top: 14px;"></div>
    <!-- :style="[BgImageTop('szafa/szafa_' + Number(outputs.szafa.wysokosc_montazowa) + '.svg')]" -->
      <div id="list-number" class="list"
      style="top:39px;left: 0px;position: absolute; width: 24px;font-size: 12px;text-align: center; border: 0px solid #abb5b2;">
        <div v-for="row in Number(outputs.szafa.wysokosc_montazowa)" :key="row"
        :style="[{height: heightU + 'px'}]"
        style="line-height: 24px;"
        >{{(Number(outputs.szafa.wysokosc_montazowa) + 1) - row}}</div>
      </div>

      <div id="list-u" class="list"
      style="top:40px; left:39px; position: absolute; width: 332px; border: 0px solid #abb5b2; margin:0px auto"
      v-if="outputs.szafa && outputs.szafa.wysokosc_montazowa">
        <div v-for="row in Number(outputs.szafa.wysokosc_montazowa)" :key="row"
        :style="[{height: heightU + 'px'}]"
        style="border: 1px solid rgb(218, 218, 218);"></div>
      </div>
      <div id="area-elements"
      style="top:40px; left:39px; position: absolute; width: 332px; border: 0px solid #abb5b2;"
      :style="[{height: (heightU * Number(outputs.szafa.wysokosc_montazowa)) + 'px'}]">

        <vue-draggable-resizable
          class-name-active="my-active-class"
          class-name-draggable="my-draggable-class"
          class-name-dragging="my-dragging-class"
          v-for="(element, index) in szafaPrzod"
          :grid='[24,24]'
          :key="index"
          :y="element.top"
          :h="element.height"
          :z="element.zindex"
          :u="element.mount"
          :x="0"
          :w="332"
          :active="false"
          :resizable="false"
          :parent="true"
          :prevent-deactivation="false"
          @dragging="(left, top) => dragging(index, left, top, element)"
          @dragstop="(left, top) => dragstop(index, left, top, element)"
          @activated="onActivated()"
          @deactivated="onDeactivated()"
          @contextmenu.native.prevent="yourhandler"
          :onDrag="onDragCallback"
          :onDragStart="onDragStartCallback()"
          :style="[BgImageTop('front/' + ((element.symbol && !element.personal) ? element.symbol.replace('/', ',') + '.png' : ((element.symbol && element.personal) ? 'WPK000.png' : 'undefined.png')))]"
          style="background-size: cover; background-color: #efefef; cursor: s-resize;"
        >
          <div style="height: inherit;" @mouseover="mouseOver = index" @mouseleave="mouseOver = null">
            <p style="color:white; margin: 0px auto; user-select: none; font-size: 10px; width: 80px; height: 16px; text-align: center; background: #6a6767;">{{ element.symbol }}</p>
            <div v-if="mouseOver === index" class="area-btn-list">
              <i @click="deleteItem(index, 'przod', element)" id="btn-list-close" class="fa fa-times close btnList">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                </svg>
              </i>
              <i v-if="element && element.podzespoly" @click="showAkcesoria(element.symbol, element.nr)" id="btn-list-service" class="fa fa-times close btnList">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                  <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                </svg>
              </i>
            </div>

            <div v-if="mouseOver === index" class="area-btn-desc">
              <div class="arrow-left"></div>
              {{ element.symbol }}<br>
              {{ element.nazwa}}
            </div>
          </div>
        </vue-draggable-resizable>
      </div>
    </div>

            <!-- @mouseover="mouseOver = index" @mouseleave="mouseOver = null"-->
            <!-- <button @click="clikOptionBtn(index), mouseOver = index" class="itemButtonDelete">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
              </svg>
            </button> -->

            <!-- <div v-if="mouseOver === index && showBtnList" class="area-btn-list"> -->

              <!-- <i class="fa fa-times close"
              v-if="element.symbol" @click="showAkcesoria(element.symbol, element.nr)"
              style="font-size: 12px;color: #009fff;line-height: 0px;position: absolute;right: -24px;top: 12px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
              </svg>
              </i> -->
              <!-- <div v-if="mouseOverInfo"
              style="font-size: 12px;color: rgb(0, 159, 255);line-height: 0px;position: absolute;right: 12px;top: 50px;transform: scale(1.4);opacity: 0.8;width: 240px;padding: 2px;line-height: 15px;text-align: right;background: #f5fdfd;padding: 6px;">
                {{element.symbol}}<br>
                {{element.nazwa}}
              </div> -->

    <!-- układanie szafy back -->
    <div id="szafa"
    style="position:relative;width: 410px;min-width: 410px;background-repeat: no-repeat;background-size: cover; margin-top:20px; float: left"
    :style="(!inputs.sameAkcesoria) ? [BgImageTop('szafa/szafa_' + Number(outputs.szafa.wysokosc_montazowa) + '.svg'), {height: hBox(Number(outputs.szafa.wysokosc_montazowa)) + 'px'}]: [{height: hBox(Number(outputs.szafa.wysokosc_montazowa)) + 'px'}]"
    v-if="outputs.szafa && Number(outputs.szafa.wysokosc_montazowa) > 0 && view ==='tyl'"
    >
      <div id="list-number" class="list"
      style="top:39px;left: 0px;position: absolute; width: 24px;font-size: 12px;text-align: center; border: 0px solid #abb5b2;">
        <div v-for="row in Number(outputs.szafa.wysokosc_montazowa)" :key="row"
        :style="[{height: heightU + 'px'}]"
        style="line-height: 24px;"
        >{{(Number(outputs.szafa.wysokosc_montazowa) + 1) - row}}</div>
      </div>

      <div id="list-u" class="list"
      style="top:40px; left:39px; position: absolute; width: 332px; border: 0px solid #abb5b2; margin:0px auto"
      v-if="outputs.szafa && outputs.szafa.wysokosc_montazowa">
        <div v-for="row in Number(outputs.szafa.wysokosc_montazowa)" :key="row"
        :style="[{height: heightU + 'px'}]"
        style="border: 1px solid rgb(218, 218, 218);"></div>
      </div>

      <div id="area-elements"
      style="top:40px; left:39px; position: absolute; width: 332px; border: 0px solid #abb5b2;"
      :style="[{height: (heightU * Number(outputs.szafa.wysokosc_montazowa)) + 'px'}]">

        <vue-draggable-resizable
          class-name-active="my-active-class"
          class-name-draggable="my-draggable-class"
          class-name-dragging="my-dragging-class"
          v-for="(element, index) in szafaTyl"
          :grid='[24,24]'
          :key="index"
          :y="element.top"
          :h="element.height"
          :z="element.zindex"
          :u="element.mount"
          :x="0"
          :w="332"
          :active="false"
          :resizable="false"
          :parent="true"
          :prevent-deactivation="false"
          @dragging="(left, top) => dragging(index, left, top, element)"
          @dragstop="(left, top) => dragstop(index, left, top, element)"
          @activated="onActivated()"
          @deactivated="onDeactivated()"
          :onDrag="onDragCallback"
          :onDragStart="onDragStartCallback()"
          :style="[BgImageTop('front/' + ((element.symbol && !element.personal) ? element.symbol.replace('/', ',') + '.png' : ((element.symbol && element.personal) ? 'WPK000.png' : 'undefined.png')))]"
          style="background-size: cover; background-color: #efefef; cursor: s-resize;"
        >
          <div style="height: inherit;" @mouseover="mouseOver = index" @mouseleave="mouseOver = null">
            <p style="color:white; margin: 0px auto; user-select: none; font-size: 10px; width: 80px; height: 16px; text-align: center;">{{ element.symbol }}</p>
            <div v-if="mouseOver === index" class="area-btn-list">
              <i @click="deleteItem(index, 'tyl', element)" id="btn-list-close" class="fa fa-times close btnList">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-dash" viewBox="0 0 16 16">
                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                </svg>
              </i>
              <i v-if="element && element.podzespoly" @click="showAkcesoria(element.symbol, element.nr)" id="btn-list-service" class="fa fa-times close btnList">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                  <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
                </svg>
              </i>
            </div>

            <div v-if="mouseOver === index" class="area-btn-desc">
              <div class="arrow-left"></div>
              {{ element.symbol }}<br>
              {{ element.nazwa}}
            </div>
          </div>
        </vue-draggable-resizable>
      </div>
    </div>
          <!-- <p style="color:white; margin: 0px auto; user-select: none; font-size: 10px; width: 80px; height: 16px; text-align: center;">{{ element.symbol }}</p> -->
          <!-- @mouseover="mouseOver = index" @mouseleave="mouseOver = null"-->
          <!-- <button @click="clikOptionBtn(index), mouseOver = index" class="itemButtonDelete">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
            </svg>
          </button> -->

            <!-- <div v-if="mouseOver === index && showBtnList" class="area-btn-list">
              <i @click="deleteItem(index, 'tyl', element)" id="btn-list-close" class="fa fa-times close btnList">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
              </svg>
              </i>
              <i v-if="element && element.podzespoly" @click="showAkcesoria(element.symbol, element.nr)" id="btn-list-service" class="fa fa-times close btnList">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"/>
              </svg>
              </i>
            </div> -->

              <!-- <i class="fa fa-times close"
              v-if="element.symbol" @click="showAkcesoria(element.symbol, element.nr)"
              style="font-size: 12px;color: #009fff;line-height: 0px;position: absolute;right: -24px;top: 12px;transform: scale(1.4);opacity: 0.8;background: border-box;width: 20px; padding:2px">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle-fill" viewBox="0 0 16 16">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
              </svg>
              </i> -->
              <!-- <div v-if="mouseOverInfo"
              style="font-size: 12px;color: rgb(0, 159, 255);line-height: 0px;position: absolute;right: 12px;top: 50px;transform: scale(1.4);opacity: 0.8;width: 240px;padding: 2px;line-height: 15px;text-align: right;background: #f5fdfd;padding: 6px;">
                {{element.symbol}}<br>
                {{element.nazwa}}
              </div> -->

    <div id="button-add" v-if="outputs.szafa && Number(outputs.szafa.wysokosc_montazowa) > 0"
    >
      <button id="btnAdd" :disabled="disabledButton" class="btn btn-success" @click="dodanie_do_szafy()">+</button>
    </div>

  <Podzespoly :showDialog='showPodzespoly' @clickClose="showPodzespoly = !showPodzespoly" :symbol="deviceSymbol" :nr="deviceNumber"/>
    <!-- {{outputs.items_inne}} -->

  <!-- {{inputs.sameAkcesoria}} -->
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'

import Podzespoly from '../components/Dialogs/Podzespoly'

export default {
  mixins: [app],
  data: function () {
    return {
      view: 'przod',
      lista: 'przod',
      showPodzespoly: false,
      deviceSymbol: '',
      deviceNumber: '',
      zajeteMiejscePrzod: 0,
      zajeteTotalPrzod: 0,
      wolneMiejscePrzod: 0,
      zajeteMiejsceTyl: 0,
      zajeteTotalTyl: 0,
      wolneMiejsceTyl: 0,
      heightU: 24,
      takenUprzod: [],
      takenUtyl: [],
      inputInne: {},
      indexPrzod: 0,
      indexTyl: 0,
      indexInne: 0,
      indexGlobal: 0,
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      tempY: null,
      active: false,
      currentFieldIndex: null,
      draging: false,
      draggingId: null,
      prevOffsetX: 0,
      prevOffsetY: 0,
      callback: true,
      szafaPrzod: [],
      szafaTyl: [],
      szafaInne: [],
      hover: false,
      mouseOver: null,
      mouseOverInfo: false,
      draggable: false,
      showBtnList: false,
      showBtnIndex: null,
      correctTop: null
    }
  },
  components: {
    VueDraggableResizable, Podzespoly
  },
  watch: {
    'outputs.szafa' () {
      this.zmianaSzafy()
    },
    loadFile (newValue) {
      if (newValue) {
        // console.log(JSON.parse(JSON.stringify(this.outputs.items_inne)))
        this.szafaPrzod = JSON.parse(JSON.stringify(this.outputs.items_przod))
        this.szafaTyl = JSON.parse(JSON.stringify(this.outputs.items_tyl))
        this.szafaInne = JSON.parse(JSON.stringify(this.outputs.items_inne))

        this.setInputSzafaInne(this.szafaInne)
        // this.typ = this.inputs.szafaPrefix
        // this.clearViewSzafa = false
        // this.sameAkcesoria = this.inputs.sameAkcesoria
        // this.selectedSzafa = JSON.parse(JSON.stringify(this.outputs.szafa)) //  Object.assign([], this.outputs.szafa)
        // this.get_akcesoria(this.selectedSzafa.value, this.selectedSzafa.wysokosc_montazowa, 'symbol')
        // this.rabatCB = this.inputs.rabatCB
        // this.rabatValue = this.inputs.rabatValue
        // this.$store.commit('app/SET_LOAD_FILE', false)
      }
    }
  },
  computed: {
    ...mapGetters('app', ['outputs', 'inputs', 'loadFile']),
    ...mapGetters('products', ['ListaPodzespoly', 'ListaAkcesoria']),
    // draggingElement: function () {
    // if (!this.draggingId) return
    // return this.szafaPrzod.find(el => el.id === this.draggingId)
    // },
    disabledButton () {
      return !((Object.keys(this.outputs.item).length > 0))
    },
    disabledView () {
      return !((this.outputs.szafa.wysokosc_montazowa > 0))
    }
  },
  methods: {
    zmianaSzafy () {
      if (this.outputs && this.outputs.szafa && this.outputs.szafa.wysokosc_montazowa) {
        this.wolneMiejscePrzod = Number(this.outputs.szafa.wysokosc_montazowa)
        this.wolneMiejsceTyl = Number(this.outputs.szafa.wysokosc_montazowa)
      }
      this.szafaPrzod = []
      this.szafaTyl = []
      this.takenUprzod = []
      this.szafaInne = []
    },
    showAkcesoria (symbol, nr) {
      this.showBtnList = false
      this.mouseOver = null
      this.deviceNumber = nr
      this.deviceSymbol = symbol
      this.showPodzespoly = true
    },
    getImgUrl (pet) {
      return require(`../assets/img/produkty/${pet}_1.png`)
    },
    hBox (wysokosc) {
      if (wysokosc === 42) {
        return 1094
      } else if (wysokosc === 27) {
        return 732
      } else if (wysokosc === 22) {
        return 610
      } else if (wysokosc < 19) {
        return 516
      }
      return null
    },
    dodanie_do_szafy () {
      // console.log('--- dodanie_do_szafy ---')
      var response = {}
      var find = []
      var item = this.outputs.item
      if (item.poza === 1) {
        var inArr = false
        // this.view = 'inne'
        this.lista = 'inne'
        Object.values(this.szafaInne).forEach(element => {
          if (element.symbol === item.symbol) {
            inArr = true
          }
        })
        // console.log(inArr)
        if (inArr === false) {
          this.indexGlobal++
          item.view = 'inne'
          item.value = 1
          item.nr = this.indexGlobal
          this.szafaInne.push(item)
          this.inputInne[item.symbol] = item.value
          // this.szafaInne.push({name: item.symbol, id: this.indexInne, iloscU: this.$options.filters.decimal(item.wysokosc_montazowa), height: `${this.$options.filters.decimal(item.wysokosc_montazowa) * this.pxU}px !important`})
          this.$store.commit('app/ADD_ITEMS', ['inne', item])
        }
      } else {
        var glebokoscSzafy = Number(this.outputs.szafa.glebokosc)
        this.lista = this.view

        var heightNewU = (item.wysokosc_montazowa) ? Math.floor(item.wysokosc_montazowa) : 0

        var newU = Number(heightNewU)
        var newHeight = newU * this.heightU
        var newMount = this.checkTop(newU)
        var newTop = (newMount[0] * this.heightU) - this.heightU

        item.view = this.view
        item.top = newTop
        item.height = newHeight
        item.value = 1
        item.u = newU
        item.mount = newMount[0]
        item.install = this.showInstall(item.mount, item.u)
        item.isActive = false
        item.zindex = 2
        item.text = ''

        // item.styleHeight = `${this.$options.filters.decimal(item.u) * this.heightU}px !important`

        if (newMount && newMount.length > 0) {
          if (this.view === 'przod') {
            this.indexPrzod++
            this.indexGlobal++
            item.nr = this.indexGlobal
            item.order = this.indexPrzod
            this.szafaPrzod.push(JSON.parse(JSON.stringify(item)))
            this.checkSlots(this.szafaPrzod)
            this.$store.commit('app/ADD_ITEMS', [this.view, item])
            if (['ARAD2', 'ARAD3', 'ARAD4', 'ARAD-S2', 'ARAD-S4'].indexOf(item.symbol) > -1) {
              find = this.ListaAkcesoria.akcesoria.filter(item => item.symbol === 'ARAS' + glebokoscSzafy)
              if (find[0]) {
                response = {
                  id: find[0].id,
                  symbol: find[0].symbol,
                  nazwa: find[0].nazwa,
                  waga: find[0].waga,
                  cena: find[0].cena,
                  wyprzedaz: find[0].wyprzedaz,
                  value: 1
                }
                this.$store.commit('app/UPDATED_OUTPUTS_PODZESPOLY', [this.indexGlobal, response])
              }
            }
          } else if (this.view === 'tyl') {
            this.indexTyl++
            this.indexGlobal++
            item.nr = this.indexGlobal
            item.order = this.indexTyl
            this.szafaTyl.push(JSON.parse(JSON.stringify(item)))
            this.checkSlots(this.szafaTyl)

            this.$store.commit('app/ADD_ITEMS', [this.view, item])
            if (['ARAD2', 'ARAD3', 'ARAD4', 'ARAD-S2', 'ARAD-S4'].indexOf(item.symbol) > -1) {
              find = this.ListaAkcesoria.akcesoria.filter(item => item.symbol === 'ARAS' + glebokoscSzafy)
              if (find[0]) {
                response = {
                  id: find[0].id,
                  symbol: find[0].symbol,
                  nazwa: find[0].nazwa,
                  waga: find[0].waga,
                  cena: find[0].cena,
                  wyprzedaz: find[0].wyprzedaz,
                  value: 1
                }
                this.$store.commit('app/UPDATED_OUTPUTS_PODZESPOLY', [this.indexGlobal, response])
              }
            }
          }
        } else {
          console.log('Brak miejsca')
          alert('Brak miejsca w szafie!')
        }
      }
    },
    clikOptionBtn (index) {
      if (this.showBtnIndex === index) {
        this.showBtnList = false
        this.showBtnIndex = null
      } else {
        this.showBtnList = true
        this.showBtnIndex = index
      }
    },
    deleteItem (index, view, item = null) {
      this.showBtnList = false
      this.mouseOver = null

      if (view === 'przod') {
        this.szafaPrzod.splice(index, 1)
        this.checkSlots(this.szafaPrzod)
        this.$store.commit('app/CHANGE_ITEMS', ['przod', this.szafaPrzod])
        this.$store.commit('app/REMOVE_OUTPUTS_PODZESPOLY', item.nr)
      } else if (view === 'tyl') {
        this.szafaTyl.splice(index, 1)
        this.checkSlots(this.szafaTyl)
        this.$store.commit('app/CHANGE_ITEMS', ['tyl', this.szafaTyl])
        this.$store.commit('app/REMOVE_OUTPUTS_PODZESPOLY', item.nr)
      } else if (view === 'inne') {
        this.szafaInne.splice(index, 1)
        // this.inputInne.splice(index, 1)
        // delete this.inputInne[symbol]
        this.$store.commit('app/CHANGE_ITEMS', ['inne', this.szafaInne])
      }
      // console.log(this.outputs.podzespoly)
    },
    dodanie_sztuk (val, symbol) {
      // console.log(val)
      // console.log(symbol)
      this.inputInne = JSON.parse(JSON.stringify(val))
      // console.log(this.inputInne)
      // this.inputInne[symbol] = JSON.parse(JSON.stringify(val[symbol]))
      this.$store.commit('app/CHANGE_ITEMS_INNE', [symbol, val[symbol]])
      if (this.loadFile) {
        this.$store.commit('app/SET_LOAD_FILE', false)
      }
    },
    yourhandler () {
      console.log('yourhandler')
    },
    checkCollision (element) {
      var cnt = 0
      if (this.view === 'przod') {
        for (var i = element.mount; i < (element.mount + element.u); i++) {
          if (this.takenUprzod.includes(i)) {
            cnt++
          }
        }
        if (cnt === 0) {
          return false
        } else {
          return true
        }
      } else if (this.view === 'tyl') {
        for (var j = element.mount; j < (element.mount + element.u); j++) {
          if (this.takenUtyl.includes(j)) {
            cnt++
          }
        }
        if (cnt === 0) {
          return false
        } else {
          return true
        }
      }
    },
    removeItemArray (top, u) {
      if (this.view === 'przod') {
        for (var i = 0; i < this.takenUprzod.length; i++) {
          if (this.takenUprzod[i] === top) {
            this.takenUprzod.splice(i, u)
            i--
          }
        }
      } else if (this.view === 'tyl') {
        for (var j = 0; j < this.takenUtyl.length; j++) {
          if (this.takenUtyl[j] === top) {
            this.takenUtyl.splice(j, u)
            j--
          }
        }
      }
    },
    showResults () {
      // console.log(this.szafaPrzod)
      // alert(this.szafaPrzod)
    },
    showInstall (mount, u) {
      // console.log(mount, u)
      var start = this.outputs.szafa.wysokosc_montazowa - mount + 1
      var install = []
      for (var i = 0; i < u; i++) {
        install.push(start - i)
      }
      return install.join()
    },
    checkSlots (items) {
      var arr = []
      items.forEach(element => {
        for (var i = 0; i < (element.u); i++) {
          arr.push(element.mount + i)
        }
      })
      arr.sort(this.compareNumbers)

      // this.zajeteMiejscePrzod = arr.length
      // this.wolneMiejscePrzod = this.outputs.szafa.wysokosc_montazowa - arr.length

      if (this.view === 'przod' && this.outputs.szafa && this.outputs.szafa.wysokosc_montazowa) {
        this.takenUprzod = arr
        this.zajeteMiejscePrzod = arr.length
        this.wolneMiejscePrzod = this.outputs.szafa.wysokosc_montazowa - arr.length
      } else if (this.view === 'tyl' && this.outputs.szafa && this.outputs.szafa.wysokosc_montazowa) {
        this.takenUtyl = arr
        this.zajeteMiejsceTyl = arr.length
        this.wolneMiejsceTyl = this.outputs.szafa.wysokosc_montazowa - arr.length
      }
    },
    checkTop (iloscU) {
      var uSzafy = (this.outputs && this.outputs.szafa) ? this.outputs.szafa.wysokosc_montazowa : 0
      var freeU = []
      var place = 0
      var newU = []

      if (this.view === 'przod') {
        for (var i = 1; i < uSzafy + 1; i++) {
          if (!this.takenUprzod.includes(i)) {
            freeU.push(i)
          }
        }
        for (var a = 0; a < freeU.length; a++) {
          for (var b = 0; b < iloscU; b++) {
            if (freeU.includes(freeU[a] + b)) {
              place++
              newU.push(freeU[a + b])
            }
          }
          if (place === iloscU) {
            break
          } else {
            place = 0
            newU = []
          }
        }
        return newU
      } else if (this.view === 'tyl') {
        for (var j = 1; j < uSzafy + 1; j++) {
          if (!this.takenUtyl.includes(j)) {
            freeU.push(j)
          }
        }
        for (var c = 0; c < freeU.length; c++) {
          for (var d = 0; d < iloscU; d++) {
            if (freeU.includes(freeU[c] + d)) {
              place++
              newU.push(freeU[c + d])
            }
          }
          if (place === iloscU) {
            break
          } else {
            place = 0
            newU = []
          }
        }
        return newU
      }
    },
    dragging (id, left, top, element) {
      // console.log('dragging', id, top, this.tempY, this.correctTop)
      this.correctTop = top
      this.draggingId = id
      element.zindex = 3
      element.y = top
      element.active = true
      element.top = top
      element.mount = (top / this.heightU) + 1
      element.install = this.showInstall(element.mount, element.u)
      // this.checkSlots(this.szafaPrzod)
    },
    dragstop (id, left, top, element) {
      // console.log('dragstop', id, top)
      element.zindex = 2
      element.active = false
      if (element && this.checkCollision((element))) {
        element.zindex = 2
        element.top = this.tempY
        element.mount = (this.tempY / this.heightU) + 1
        element.install = this.showInstall(element.mount, element.u)
      } else {
        // this.currentField.y = top
      }
      if (this.view === 'przod') {
        this.checkSlots(this.szafaPrzod)
        this.$store.commit('app/CHANGE_ITEMS', ['przod', this.szafaPrzod])
      } else if (this.view === 'tyl') {
        this.checkSlots(this.szafaTyl)
        this.$store.commit('app/CHANGE_ITEMS', ['tyl', this.szafaTyl])
      }
      this.draggingId = null
      this.callback = true
    },
    onActivated () {
      // console.log('onActivated', this.draggingId)
      this.active = true
      // this.mouseOver = this.draggingId
    },
    onDeactivated () {
      // console.log('onDeactivated')
      this.currentFieldIndex = null
      this.active = false
      this.tempY = null
      // this.mouseOver = null
    },
    onDragCallback (x, y) {
      // console.log('onDragCallback')

      if (this.view === 'przod') {
        if (this.callback && this.szafaPrzod[this.draggingId] && this.draggingId !== null) {
          // console.log('onDragCallback', this.tempY, this.szafaPrzod[this.draggingId].top)
          this.removeItemArray(this.szafaPrzod[this.draggingId].mount, this.szafaPrzod[this.draggingId].u)
          this.callback = false
          this.tempY = this.szafaPrzod[this.draggingId].top
        }
      } else if (this.view === 'tyl') {
        if (this.callback && this.szafaTyl[this.draggingId] && this.draggingId !== null) {
          this.removeItemArray(this.szafaTyl[this.draggingId].mount, this.szafaTyl[this.draggingId].u)
          this.callback = false
          this.tempY = this.szafaTyl[this.draggingId].top
        }
      }
    },
    onDragStartCallback (ev) {
    },
    checkHitTest (top, height) {
    },
    compareNumbers (a, b) {
      return a - b
    },
    eventMouseOver () {
      console.log('eventMouseOver')
    },
    eventMouseOut () {
      console.log('eventMouseOut')
    },
    eventMouseUp () {
      console.log('eventMouseUp')
    },
    setInputSzafaInne (elements) {
      if (elements.length > 0) {
        elements.forEach(element => {
          this.inputInne[element.symbol] = element.value
        })
      }
      // this.checkTop()
      this.view = 'tyl'
      this.checkSlots(this.szafaTyl)
      this.view = 'przod'
      this.checkSlots(this.szafaPrzod)
    }
  },
  created () {
    this.$store.commit('app/CHANGE_ITEMS', ['przod', []])
    this.$store.commit('app/CHANGE_ITEMS', ['tyl', []])
  }
}
</script>

<style>
.itemButtonDelete {
  position: absolute;
  width: 25px;
  display: block;
  right: 0px;
  top: 0px;
  background: #6c6c6c none repeat scroll 0% 0%;
  color: white;
  cursor: pointer;
  border: medium none;
  height: 22px;
}
.area-btn-list {
  /* position: absolute;width: 53px;height: 25px;right: -54px;top: -1px; */
  position: absolute;
  width: 53px;
  height: 22px;
  right: -32px;
  top: 0px;
}
.btnList {
  background: #efefef;
  font-size: 12px;
  line-height: 0px;
  position: absolute;
  transform: scale(1.4);
  opacity: 0.8;
  width: 20px;
  padding:2px;
}
#btn-list-close {
  top: 3px;
  color: red;
  z-index: 999;
  padding: 0px;
  width: 16px;
  left: 3px;
  background: red;
  height: 17px;
  border: 0px;
  color: white;
  opacity: 0.6;
  /* right:30px;
  top: 2px;
  color: red;
  z-index: 999; */
}
#btn-list-close:hover {
opacity: 1;
}
#btn-list-service {
  top: 3px;
  color: white;
  z-index: 999;
  padding: 0px;
  width: 16px;
  left: 26px;
  background: green;
  height: 17px;
  border: 0px;
  color: white;
  opacity: 0.4;
}
#btn-list-service:hover {
opacity: 1;
}
#btn-list-service svg{
  top: 2px;
  position: relative;
}

.my-class {
    background-color: green;
    border: 1px solid red;
    /* -webkit-transition: background-color 200ms linear;
    -ms-transition: background-color 200ms linear;
    transition: background-color 200ms linear; */
}

.my-dragging-class {
    background-color: rgba(13, 95, 19, 0.0) !important;
    border: 1px solid black;
}
.my-draggable-class {
    background-color: #efefef;
}

.vdr {
  -ms-touch-action: none;
  touch-action: none;
  border: 1px dashed #636363;
}

#btnViews #btnView {
color: #535353 !important;
border: 1px solid #d8d8d8 !important;
width: 75px;
text-align: left;
padding: 2px 6px;
margin-bottom: 5px;
cursor: pointer;
}
#btnViews #btnView:hover {
color: #00c3ff !important;
border: 1px solid #848484 !important;
}
#btnViews #btnView.focus, #btnViews #btnView:focus {
  outline: 0;
  box-shadow: none;
}
#btnViews #btnView{
text-transform: uppercase;
}
#btnViews #btnView.active {
color: #00c3ff !important;
border: 2px solid #00c3ff !important;
background: white;
text-transform: uppercase;
}

#button-add  {
  position: absolute;
  top: 349px;
  font-size: 14px;
  right: 0px;
  text-align: right;
}
@media only screen and (max-width: 830px) {
  #component-ItemsRack {
    display: grid !important;
  }
  #button-add {
    /* display: none; */
    position: relative;
    text-align: left;
    top: 0px;
  }
  #button-add #btnAdd {
    height: 40px;
    border-radius: 0px;
    width: 95%;
    line-height: 10px;
  }
}

#btnAdd, #btnAdd:hover, #btnAdd:focus {
  height: 166px;
  border-radius: 40px 0px 0px 40px;
  background-color: #00c3ff;
  width: 43px;
  font-size: 30px;
  box-shadow: 0 0 0 0rem rgba(72,180,97,.5);
  border: 3px solid white;
    box-shadow: -4px 3px 4px #d0d0d0;
}

#info-blink {
  position: absolute;
right: 12px;
top: 5px;
border: 0px solid #00c3ff;
width: 335px;
height: 38px;
}
#info-blink > p {
  position: absolute;
right: 45px;
top: 7px;
width: 300px;
font-weight: bold;
font-size: 20px;
color: #00c3ff;
}
#info-blink > svg {
  color: #00c3ff;
position: relative;
left: 135px;
}

.blink {
        animation: blink-animation 1s steps(5, start) infinite;
        -webkit-animation: blink-animation 1s steps(5, start) infinite;
      }
      @keyframes blink-animation {
        to {
          visibility: hidden;
        }
      }
      @-webkit-keyframes blink-animation {
        to {
          visibility: hidden;
        }
      }

.area-btn-desc {
  position: relative;
  z-index: 10;
  background: #ffffffde;
  left: 368px;
  text-align: left;
  top: -16px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 8px;
  font-size: 12px;
  font-weight: bold;
  font-style: italic;
  border: 1px solid #d1d1d1;
  color: #5d5d5d;
}

.arrow-left {
width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid white;
  left: -10px;
  position: absolute;
  top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/ItemsRack.vue